import {
  HttpService,
  ApplicationService,
  CommitteeProvider,
  SearchProvider,
  ViewProvider,
  OperProvider,
  OperPostProvider,
  ApplicationProvider,
  ApplicationAddProvider,
} from '@lk/api'

export const makeApplicationService = (http: HttpService, baseUrl: string) =>
  new ApplicationService(
    new CommitteeProvider(http, baseUrl),
    new SearchProvider(http, baseUrl),
    new ViewProvider(http, baseUrl),
    new OperProvider(http, baseUrl),
    new OperPostProvider(http, baseUrl),
    new ApplicationProvider(http, baseUrl),
    new ApplicationAddProvider(http, baseUrl),
  )
